"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const router_1 = require("next/router");
const _1 = require(".");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
const utils_1 = require("../utils");
const TRANSLATIONS = {
    'es': 'Ver toda nuestra selección de',
    'en': 'View all our selection of',
    'ca': 'Veure tota la nostra selecció de',
    'de': 'Sehen Sie sich unsere gesamte Auswahl an',
    'fr': 'Voir toute notre sélection de ',
    'pt': 'Ver toda a nossa seleção de',
    'it': 'Vedi tutta la nostra selezione di'
};
const mediaArrowIcon = {
    type: 'image',
    alt: 'Icon arrow',
    default: {
        src: '/images/svg/i--arrow.svg',
        size: { width: 45, height: 39 }
    }
};
exports.CategoryCard = (0, react_1.memo)(({ data }) => {
    const { locale: localeRouter } = (0, router_1.useRouter)();
    const locale = (0, utils_1.getLang)(localeRouter);
    const { name, slug } = data;
    return ((0, jsx_runtime_1.jsx)(Article, { children: (0, jsx_runtime_1.jsx)(StyledLink, Object.assign({ href: `/product/${slug ? slug[locale] : ''}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'container' }, { children: [(0, jsx_runtime_1.jsx)(_1.Figure, { media: mediaArrowIcon }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", TRANSLATIONS[locale], " ", name, " "] })] })) })) }));
});
const Article = styled_components_1.default.article `
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 20px;
  border: 2px solid ${({ theme }) => theme.colors.creme};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  height: ${(0, styles_1.vw)(277, 'mobile')};
  margin-right: ${(0, styles_1.vw)(5, 'mobile')};
  overflow: hidden;
  position: relative;
  transition: 200ms border-color ${({ ease }) => ease};
  width: ${(0, styles_1.vw)(175, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(277, 'nexus7')};
    margin-right: ${(0, styles_1.vw)(5, 'nexus7')};
    width: ${(0, styles_1.vw)(175, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(360, 'desktop')};
    margin-right: ${(0, styles_1.vw)(5, 'desktop')};
    width: ${({ $narrow }) => $narrow ? `${(0, styles_1.vw)(204, 'desktop')}` : `${(0, styles_1.vw)(261, 'desktop')}`};

    &.selected,
    &:hover {
      border-color: ${({ theme }) => theme.colors.red};
    }
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 360px;
    margin-right: 5px;
    width: ${({ $narrow }) => $narrow ? '204px' : '261px'};
  }

  .container {
    display: grid;
    align-content: center;
    height: 100%;

    span {
      display:block;
      &:last-child {
        color: ${({ theme }) => theme.colors.darkcreme};
        text-align: center;
        margin:20px auto;
        width: 80%;
      }
    }
    figure {
      height: ${(0, styles_1.vw)(23, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(23, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(45, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 45px;
      }
    }
  }

`;
const StyledLink = styled_components_1.default.a `
  align-items: flex-start;
  display:flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  width: 100%;
`;
